import type { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';

// Router der App — mit einer Abweichung vom Standard: Seitenwechsel laufen
// NICHT als „Hintergrund-Übergang" (React.startTransition).
//
// React Router 7 macht das von Haus aus. Dann gilt: Muss die nächste Seite
// erst noch geladen werden, bleibt bis dahin die ALTE Seite sichtbar und
// bedienbar, während oben schon die neue Adresse steht — ohne jeden Hinweis,
// dass gewechselt wird. Genau so kam es zu Ticket QJ99 (Sharina, 13.10.2026):
// Nach „Absagen & neu buchen" stand das Kundenprofil weiter da, der Termin
// noch als „aktiv". Der zweite Klick auf „Umbuchen" traf einen längst
// abgesagten Termin („Buchung ist nicht aktiv"); erst Neuladen zeigte die
// Terminsuche, die längst in der Adresse stand.
//
// Ohne Übergang zeigt der Inhaltsbereich beim Wechsel sofort „Lade…" (die
// Ladegrenze in Layout.tsx), Navigation, Dialer und laufendes Gespräch
// bleiben stehen. Was auf dem Bildschirm steht, passt damit immer zur Adresse.
export function AppRouter({ children }: { children: ReactNode }) {
  return <BrowserRouter useTransitions={false}>{children}</BrowserRouter>;
}
